export default __webpack_public_path__ + "static/media/Lluvia_ligera_a_moderada.ad95bd09.svg";